import {useParams} from 'react-router-dom'
import {parseISO} from 'date-fns'

import commonStyles from '../styles.module.scss'
//import useStore from 'base/store'
import {MeterStat, Period} from 'common/components'
import {formatMoney} from 'common/helpers'
import {ProjectChart, useGetProject} from '..'

export default function ProjectAboutIndicators() {
  const params = useParams()
  const {data: project} = useGetProject(params.uuid)

  return (
    <div className={commonStyles.indicatorsContainer}>
      <div className={commonStyles.indicatorsGrid}>
        
        <ProjectChart project={project} />
        
        <div className={commonStyles.indicatorsStats}>
          <MeterStat
            large
            type="stone3"
            title="Facility limit 2"
            value={formatMoney(project.facilityLimit2, {cents: true})}
            label="" // "including interest & fees"
          />
          <MeterStat
            type="charcoal"
            title="Current balance"
            value={formatMoney(project.balance, {cents: true})}
            label={`${formatMoney(project.availableBalance, {
              cents: true,
            })} available`}
          />
          <MeterStat
            greyTitle
            type="dotsYellow"
            title="Accrued interest"
            value={formatMoney(project.accruedInterest, {cents: true})}
          />
        </div>
        
        <div className={commonStyles.indicatorsStats}>
          <MeterStat // right
            large
            type="transparent"
            title="Facility limit 1"
            value={formatMoney(project.facilityLimit1, {cents: true})}
            label="" // "excluding interest & fees"
          />
          <MeterStat // right
            type="cyan"
            title="Drawn amount"
            value={formatMoney(project.withdrawn, {cents: true})}
            label={`${formatMoney(project.availableWithdrawal, {
              cents: true,
            })} available`}
          />
          <MeterStat // right
            greyTitle
            type="dotsBlack"
            title="Pending drawdown"
            value={formatMoney(project.withdrawPending, {cents: true})}
          />
        </div>
        
      </div>
      <div className={commonStyles.indicatorsPeriod}>
        <Period
          withOverdue={project.status !== 'closed'}
          openDate={parseISO(project.openDate)}
          maturityDate={parseISO(project.maturityDate)}
        />
      </div>
    </div>
  )
}
